import axios from 'axios';
import { BASE_PATH_SERVER } from './config';

// Lista de clientes del sistema nuevo (`GET /clientes` → ClienteService). Devuelve
// un arreglo. Authorization + retry 401 los inyecta el interceptor global de axios.
// Ante error retorna `[]` para que los consumidores queden array-safe.

export const getClientsApi = async () => {
  try {
    const { data } = await axios.get(`${BASE_PATH_SERVER}clientes`);
    return Array.isArray(data) ? data : [];
  } catch (err) {
    return [];
  }
};
